// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-medium-badge-6251be97"};